import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ColumnRendererComponent } from '@gea/digital-ui-lib';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'checkboxRenderer',
  imports: [TableModule],
  template: '<p-tableRadioButton [value]="rowData"></p-tableRadioButton>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxRendererComponent<T> implements ColumnRendererComponent<T> {
  rowData?: T;
}
